import { EndorsementPremiumChange } from '@domain/schemas/endorsement-premium-change';

import type { EndorsementFormState } from '../types';

export function getBlankEndorsementTemplateValues(): Partial<EndorsementFormState> {
  return {
    additional_premium: undefined,
    effective_date: undefined,
    expiry_date: undefined,
    internal_description: undefined,
    premium_change: EndorsementPremiumChange.NONE,
    reason: undefined,
    reference: undefined,
    type: undefined,
  };
}
